// Lightweight helpers for parsing and validating geographic coordinates

export function parseNumber(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : null;
}

export function isValidCoord(lat, lng) {
    return (
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
    );
}

export function parseAndValidateLngLat(longitude, latitude) {
    const lng = parseNumber(longitude);
    const lat = parseNumber(latitude);
    return {lat, lng, valid: isValidCoord(lat, lng)};
}

// Convenience: converts to [lng, lat] tuple or null if invalid
export function toLngLatTuple(longitude, latitude) {
    const {lat, lng, valid} = parseAndValidateLngLat(longitude, latitude);
    return valid ? [lng, lat] : null;
}
